import { render } from "./EditGarden.vue?vue&type=template&id=29081396&scoped=true"
import script from "./EditGarden.vue?vue&type=script&lang=js"
export * from "./EditGarden.vue?vue&type=script&lang=js"

import "./EditGarden.vue?vue&type=style&index=0&id=29081396&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29081396"]])

export default __exports__